import LinkedInPostDto from '@/Domain/Entities/LinkedInPostDto';
import axios from 'axios';
const baseURL = process.env.VUE_APP_ROOT_API + 'api/linkedin/auth';

export default class LinkedinService {
    public static async getLinkedinAuthorizationEndpoint(): Promise<{authUrl: string}> {
        return new Promise((resolve, reject) => {
            axios.get('/url', { baseURL })
                .then(response => resolve(response.data))
                .catch(error => reject());
        });
    }

    public static async exchangeCallback(linkedInPost: LinkedInPostDto): Promise<any> {
        return new Promise((resolve, reject) => {
            axios.post('/callback', linkedInPost.toServer(), { baseURL })
                .then(response => resolve(response.data))
                .catch(error => reject(error));
        });
    }
}
